import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import "./Home.css";
import WaveCanvas from "../components/WaveCanvas";
import ProfileRipple from "../components/ProfileRipple";
import Timeline from "../components/Timeline";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import useSectionHeader from "../hooks/useSectionHeader";
import { wrapMixedText } from "../utils/textHelpers";

function Home() {
  const { t } = useTranslation("home");

  const heroRef = useRef(null);
  const aboutRef = useRef(null);

  // reusable hooks
  useSectionHeader(heroRef, "home:header.hero");
  useSectionHeader(aboutRef, "home:header.about");

  const heroAnimationVariants = {
    initial: {
      opacity: 0,
    },
    animate: (delayFactor) => ({
      opacity: 1,
      transition: {
        duration: 0.3,
        delay: 0.4 * delayFactor,
      },
    }),
  };

  return (
    <>
      <section id="hero" ref={heroRef}>
        <WaveCanvas />

        <div id="hero-headers">
          <motion.h1
            variants={heroAnimationVariants}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            custom={1}
          >
            {wrapMixedText(t("hero.title"))}
          </motion.h1>

          <motion.h3
            variants={heroAnimationVariants}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            custom={2}
          >
            {t("hero.subtitle")}
          </motion.h3>
        </div>

        <motion.div
          id="hero-button"
          variants={heroAnimationVariants}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
          custom={3}
        >
          <NavLink to="/#about">
            <span>{t("hero.button")}</span>
          </NavLink>
        </motion.div>
        
        <motion.p
          id="hero-comment"
          variants={heroAnimationVariants}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
          custom={4}
        >
          {t("hero.comment")}
        </motion.p>
      </section>

      <section id="about" ref={aboutRef}>
        <div id="profile-grid">
          <div className="profile-item">
            <p id="introduction">
              {t("about.intro")}
            </p>
          </div>
          <div className="profile-item">
            <ProfileRipple />
          </div>
          <div id="timeline-wrapper" className="profile-item">
            <Timeline />
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
